import AppHeader from "../../layout/AppHeader";
import Delivery from '../../xpost/views/register/delivery/Delivery.vue';
import DeliveryAdd from '../../xpost/views/register/delivery/DeliveryAdd.vue';

const DeliveryRoutes = [
    {
        path: "/cadastro/destinatario",
        name: "delivery",
        components: {
            header: AppHeader,
            default: Delivery
        }
    },
    {
        path: "/cadastro/destinatario/adicionar",
        name: "delivery.add",
        components: {
            header: AppHeader,
            default: DeliveryAdd
        }
    },
    {
        path: '/cadastro/destinatario/adicionar/:id',
        name: 'delivery.edit',
        components: {
            header: AppHeader,
            default: DeliveryAdd
        }
    }
]

export default DeliveryRoutes;